// This kitchen screen's own id, and the station it last showed (M2, Oct 2026). The till keeps
// which station a screen shows (backend routes/kitchen_screens.py) against an id the browser
// makes once; the station is kept here too, so a reload paints the right board before the
// till answers, and still does with the till's server out of reach.
const KEY = 'verlo_kitchen_screen';

const read = () => {
  try { return JSON.parse(localStorage.getItem(KEY) || 'null') || {}; } catch { return {}; }
};
const write = (v) => {
  try { localStorage.setItem(KEY, JSON.stringify(v)); } catch { /* private mode: the till still knows */ }
};
const newId = () => (globalThis.crypto?.randomUUID?.()
  || `screen-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`);

export function screenId() {
  const s = read();
  if (s.id) return s.id;
  const id = newId();
  write({ ...s, id });
  return id;
}

export const cachedStation = () => read().station || null;
export const cacheStation = (station) => write({ ...read(), id: screenId(), station });
